/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from "@emotion/react";
import { changeStyleWithHosting } from "utility/hosting";

import type { CSSProperties, FC, ReactNode } from "react";

type Props = {
  as: "h1" | "h2" | "h3" | "h4";
  children: ReactNode;
  fontSize: number;
  fontWeight: CSSProperties["fontWeight"];
};

export const SectionHeading: FC<Props> = ({
  as,
  children,
  fontSize,
  fontWeight,
}) => {
  const classes = styles({ fontSize, fontWeight });
  const Heading = as;

  return <Heading css={classes.root}>{children}</Heading>;
};

const styles = ({
  fontSize,
  fontWeight,
}: Pick<Props, "fontSize" | "fontWeight">) => {
  const { accentColor } = changeStyleWithHosting().baseStyles;

  return {
    root: css`
      padding-left: 12px;
      margin: 0;
      font-size: ${fontSize}px;
      font-weight: ${fontWeight};
      line-height: 1.5;
      border-left: 3px solid ${accentColor};
    `,
  };
};
